import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./home/Home";
import Navbar from "./global/Navbar";
import About from "./about/About";
import Footer from "./global/Footer";
import Contact from "./contact/Contact";
import Gallery from "./gallery/Gallery";
import Services from "./services/Services";
import Products from "./products/Products";
import WhatsAppButton from "./global/WhatsAppButton";
import CallButton from "./global/CallButton";
import BalconySafetyNets from "./subpages/BalconySafetyNets";
import ChildrenSafetyNets from "./subpages/ChildrenSafetyNets";
import IndustrialSafetyNets from "./subpages/IndustrialSafetyNets";
import PetsSafetyNets from "./subpages/PetsSafetyNets";
import DucteriaNets from "./subpages/DucteriaNets";
import MonkeySafetyNets from "./subpages/MonkeySafetyNets";
import CricketPracticeNets from "./subpages/CricketPracticeNets";
import BirdSpikes from "./subpages/BirdSpikes";
import FloatingBar from "./subpages/Floatin";
import BlogPage from "./blogs/BlogPage";
import ThankYou from "./global/ThankYouPage";
import InvisibleGrills from "./subpages/InvisibleGrills";

const App = () => {
  return (
    <div>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/services" element={<Services />} />
          <Route path="/expertise" element={<Products />} />
          <Route path="/balconysafenets" element={<BalconySafetyNets />} />
          <Route path="/childernsafetynets" element={<ChildrenSafetyNets />} />
          <Route path="/invisiblegrills" element={<InvisibleGrills />} />
          <Route
            path="/industrialsafetynets"
            element={<IndustrialSafetyNets />}
          />
          <Route path="/petssafetynets" element={<PetsSafetyNets />} />
          <Route path="/ducterianets" element={<DucteriaNets />} />
          <Route path="/monkeysafetynets" element={<MonkeySafetyNets />} />
          <Route
            path="/cricketpracticenets"
            element={<CricketPracticeNets />}
          />
          <Route path="/birdspikes" element={<BirdSpikes />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/thankyou" element={<ThankYou />} />
        </Routes>
        <CallButton />
        <WhatsAppButton />
        <FloatingBar />
        <Footer />
      </BrowserRouter>
    </div>
  );
};

export default App;
